import React from 'react';
import { useSelector } from 'react-redux';

import { BizContainer } from '../MyBizBlog/MyBizBlogStyle';
import * as S from './MyBizBenefitsStyle';
import {
	Heading,
	SubTitle,
	FlexDiv,
	GenericP,
	GenericDiv
} from '../../../../common/Styles';
import { OrangeBorder } from '../../Style';

const Benefits = ({ isMobile }) => {
	const myBizBenefitsData = useSelector((state) => state.resource.myBizBenefitsData || {});
	const { heading, content = [] } = myBizBenefitsData;
	return (
		<BizContainer id='Benefits'>
			<OrangeBorder />
			<GenericDiv left_P={`${isMobile ? '16' : 'auto'}`}>
				<Heading
					fontSize={`${isMobile ? '24px' : '40px'}`}
					marBt={`${isMobile ? '35px' : '90px'}`}
					dangerouslySetInnerHTML={{ __html: heading }}
				/>
			</GenericDiv>
			<S.MyBenefitsListWrap className='container'>
				{content.map((item, index) => {
					const { imgUrl, heading, subHeading } = item;
					return (
						<li key={imgUrl} id={`benefits${index}`}>
							<FlexDiv bottom_M='65' $width='250px' justify='space-between' align='center'>
								<img src={imgUrl} />
							</FlexDiv>
							<SubTitle
								fSize={`${isMobile ? '18px' : '24px'}`}
								bottom_M={`${isMobile ? '8' : '4'}`}
								color='#3b385e'>
								{heading}
							</SubTitle>
							<GenericP fsize='12px' text_align='center'>{subHeading}</GenericP>
						</li>
					);
				})}
			</S.MyBenefitsListWrap>
		</BizContainer>
	);
};

export default Benefits;
